/* eslint-disable no-console */
import ApplicationConf from 'conf/ApplicationConf'
import { keyBy } from 'lodash'
import { toast } from 'react-toastify'
import { createAppSlice } from 'common/createAppSlice'
import { aquaFetch } from 'common/utils/ActionUtils'
import { STATUS } from 'common/constants/storeConstants'

const initialState = {
    status: STATUS.IDLE,
    byLogin: {},
    allLogins: [],
}

const UsersSlice = createAppSlice({
    name: 'home',
    initialState,
    reducers: (create) => ({
        reset: create.reducer(() => initialState),

        fetchUsers: create.asyncThunk(
            async (_, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.auth.users())
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement des utilisateurs')
                    return rejectWithValue(err)
                }
            },
            {
                pending: state => {
                    state.status = STATUS.LOADING
                },
                rejected: state => {
                    state.status = STATUS.REJECTED
                },
                fulfilled: (state, action) => {
                    state.status = STATUS.SUCCEEDED
                    const byLogin = keyBy(action.payload, 'login')
                    state.byLogin = byLogin
                    state.allLogins = action.payload.map(user => user.login)
                },
                options: {
                    condition: (_, { getState }) => {
                        const { admin } = getState()
                        return admin.users.status === STATUS.IDLE
                    },
                    dispatchConditionRejected: true,
                },
            }
        ),
        updateUserHabs: create.asyncThunk(
            async (user, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.auth.users(), { body: user, method: 'PUT' })
                    toast.success('Habilitations modifiées avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la modification des habilitations')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
    }),
    selectors: {
        selectUsers: (state) => state.allLogins.map(id => state.byLogin[id]),
    },
})

export const { fetchUsers, updateUserHabs } = UsersSlice.actions
export const {
    selectUsers,
} = UsersSlice.getSelectors((state) => state.admin.users)
export default UsersSlice